module.exports = __webpack_public_path__ + "img/2018-12-16-1.c1d127f7.jpeg";